import { Button } from "../../../../BP2Components";
import { useState } from "react";
import PropTypes from "prop-types";
import SettingsModal from "../../../../Modal/SettingsModal";
import MessageModal from "../../Modals/MessageModal";
import IntlMessages from "../../../../../util/IntlMessages";
import "./SingleSysButton.less";
import { useIntl } from "react-intl";
import { useMessageItem } from "../../../../../context/MessageItemContext/MessageItemContext";

const SingleSysButton = ({
   sysButtonKey,
   sysButtonValue,
   handleSysAction,
   windowWidth,
   instanceId,
   recordId,
   isCaseAction,
   linkToCase,
   setIsDropdownOpen,
   disabled = false,
}) => {
   const intl = useIntl();
   const [isOpen, setIsOpen] = useState(false);

   const { isButtonClicked, setIsButtonClicked } = useMessageItem();

   const isMoveForward = sysButtonKey === "moveForward";

   const handleClose = () => {
      setIsButtonClicked(false);
      if (setIsDropdownOpen) {
         requestAnimationFrame(() => {
            setIsDropdownOpen(false);
         });
      }
   };

   return (
      <SettingsModal
         sysButtonKey={sysButtonKey}
         isOpen={isOpen}
         setIsOpen={setIsOpen}
         onClose={handleClose}
         key={sysButtonKey}
         validateBeforeOpen={!isCaseAction ? true : false}
         className={isMoveForward ? "move-forward-modal" : ""}
         customAvatar={
            <Button
               buttonType="default"
               key={sysButtonKey}
               className="system-buttons__single"
               size={windowWidth > 933 ? "middle" : "small"}
               style={{ minWidth: `${windowWidth > 933 ? "120px" : "100px"}` }}
               onClick={() => setIsButtonClicked(true)}
               disabled={disabled || isButtonClicked}
            >
               <IntlMessages id={`action.${sysButtonKey}`} />
            </Button>
         }
         children={
            <MessageModal
               sysAction={{ name: sysButtonKey, data: sysButtonValue }}
               className={isMoveForward ? "move-forward-modal-body" : ""}
               handleSysAction={handleSysAction}
               closeModal={() => {
                  setIsOpen(false);
               }}
               instanceId={instanceId}
               recordId={recordId}
               linkToCase={linkToCase}
            />
         }
         title={intl.formatMessage({ id: `action.${sysButtonKey}` })}
      />
   );
};

SingleSysButton.propTypes = {
   sysButtonKey: PropTypes.string.isRequired,
   sysButtonValue: PropTypes.object.isRequired,
   handleSysAction: PropTypes.func.isRequired,
};

export default SingleSysButton;
